import type { mutationCreateOfferOrdersVariables } from 'Constants/graphql/mutations/__generated__/mutationCreateOfferOrders'

import { OrderType } from 'Portal/__generated__/globalTypes'

import { BULK_ORDER_THRESHOLD } from './useOfferOrderMutation.constants'

export const isBulkOfferOrder = (
  variables?: mutationCreateOfferOrdersVariables,
): boolean => {
  const orders = variables?.input.orders ?? []
  const deviceCount = orders
    .flatMap(order => order.items)
    .reduce((total, item) => total + item.quantity, 0)

  return (
    orders.every(order => order.orderType === OrderType.newDevice) &&
    deviceCount > BULK_ORDER_THRESHOLD
  )
}
